/**
 * FolderIcon component - Displays Google Drive folder icon
 */

import React from 'react';

interface FolderIconProps {
  color?: 'blue' | 'orange';
  className?: string;
}

const FolderIcon: React.FC<FolderIconProps> = ({ color = 'blue', className = '' }) => {
  const fillColor = color === 'orange' ? '#FBBC04' : '#4285F4';

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8 12C8 10.8954 8.89543 10 10 10H19.1716C19.702 10 20.2107 10.2107 20.5858 10.5858L23.4142 13.4142C23.7893 13.7893 24.298 14 24.8284 14H38C39.1046 14 40 14.8954 40 16V36C40 37.1046 39.1046 38 38 38H10C8.89543 38 8 37.1046 8 36V12Z"
        fill={fillColor}
      />
      <path
        d="M8 16C8 14.8954 8.89543 14 10 14H38C39.1046 14 40 14.8954 40 16V20H8V16Z"
        fill={fillColor}
        fillOpacity="0.8"
      />
    </svg>
  );
};

export default FolderIcon;

